import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiTrendingDown } from 'react-icons/fi';
import { useTheme } from '../../contexts/ThemeContext';
import WidgetHeader from './WidgetHeader';

interface BurndownWidgetProps { data: any | null; loading: boolean }

const BurndownWidget: React.FC<BurndownWidgetProps> = ({ data, loading }) => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();

  if (loading) return (
    <div className={`rounded-lg border-l-4 border-emerald-500 p-3 ${darkMode ? 'bg-gray-800/60' : 'bg-white'}`}>
      <WidgetHeader compact icon={<FiTrendingDown className="w-3.5 h-3.5 text-emerald-400" />} title="Burndown" accentColor="emerald" />
      <div className={`h-8 animate-pulse rounded ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`} />
    </div>
  );

  if (!data) return (
    <div className={`rounded-lg border-l-4 border-emerald-500 p-2 ${darkMode ? 'bg-gray-800/60' : 'bg-white'}`}>
      <WidgetHeader compact icon={<FiTrendingDown className="w-3.5 h-3.5 text-emerald-400" />} title="Burndown" accentColor="emerald" subtitle="No data" />
    </div>
  );

  const completed = data.completed ?? data.done ?? 0;
  const remaining = data.remaining ?? Math.max(0, (data.total ?? 0) - completed);
  const total = completed + remaining;
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className={`rounded-lg border-l-4 border-emerald-500 p-3 ${darkMode ? 'bg-gray-800/60' : 'bg-white'}`}>
      <WidgetHeader
        compact
        icon={<FiTrendingDown className="w-3.5 h-3.5 text-emerald-400" />}
        title="Burndown"
        accentColor="emerald"
        subtitle={`${pct}%`}
        actions={
          <button onClick={() => navigate('/work/chat')} className="p-1 text-[10px] text-emerald-400 hover:text-emerald-300 font-medium">
            Details &rarr;
          </button>
        }
      />
      <div className={`text-xs mb-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        <span className="font-bold text-emerald-400">{completed}</span> done / <span className="font-bold">{remaining}</span> remain
      </div>
      <div className={`h-2 rounded-full overflow-hidden ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
        <div className="h-full rounded-full bg-gradient-to-r from-emerald-500 to-teal-400 transition-all duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className={`text-[10px] mt-1 text-right ${darkMode ? 'text-gray-600' : 'text-gray-500'}`}>{pct}%</div>
    </div>
  );
};

export default BurndownWidget;
